import { useEffect, useRef } from 'react';
import { subscribeCatalogChanges } from './catalog-change-sync';

/** Refresh saved catalog data without clearing filters or replacing open edit forms. */
export function useCatalogRefresh(refresh: () => void) {
  const latest = useRef(refresh);
  useEffect(() => { latest.current = refresh; }, [refresh]);
  useEffect(() => {
    const refreshVisible = () => {
      if (document.visibilityState !== 'hidden') latest.current();
    };
    const unsubscribe = subscribeCatalogChanges(refreshVisible);
    const timer = window.setInterval(refreshVisible, 30_000);
    window.addEventListener('focus', refreshVisible);
    document.addEventListener('visibilitychange', refreshVisible);
    return () => {
      unsubscribe();
      window.clearInterval(timer);
      window.removeEventListener('focus', refreshVisible);
      document.removeEventListener('visibilitychange', refreshVisible);
    };
  }, []);
}
